import React from 'react';
import { SectionPage } from 'components/section/SectionPage';
import DoctorsView from 'components/doctors/DoctorsView';
import SectionContainer from 'components/section/SectionContainer';

const DoctorsHome = () => {
  const pages: SectionPage[] = [
    {id: "doctors", uri: "/doctors", component: DoctorsView}
  ];
  return (
      <SectionContainer sectionPages={pages}/>
  );
};

export default DoctorsHome;
